export const familyMessages = {
	MSG_FAMILY_CREATED_SUCCESS: 'Família criada com sucesso!',
	MSG_FAMILY_UPDATED_SUCCESS: 'Família atualizada com sucesso!',
	MSG_FAMILY_DELETED_SUCCESS: 'Família excluída com sucesso!',
	MSG_SUBFAMILY_CREATED_SUCCESS: 'Subfamília criada com sucesso!',
	MSG_SUBFAMILY_UPDATED_SUCCESS: 'Subfamília atualizada com sucesso!',
	MSG_SUBFAMILY_DELETED_SUCCESS: 'Subfamília excluída com sucesso!',
	MSG_MODEL_CREATED_SUCCESS: 'Modelo criado com sucesso!',
	MSG_MODEL_UPDATED_SUCCESS: 'Modelo atualizado com sucesso!',
	MSG_MODEL_DELETED_SUCCESS: 'Modelo excluído com sucesso!',

	MSG_FAMILY_CREATE_ERROR: 'Erro ao criar família!',
	MSG_FAMILY_UPDATE_ERROR: 'Erro ao atualizar família!',
	MSG_FAMILY_DELETE_ERROR: 'Erro ao excluir família!',
	MSG_SUBFAMILY_CREATE_ERROR: 'Erro ao criar subfamília!',
	MSG_SUBFAMILY_UPDATE_ERROR: 'Erro ao atualizar subfamília!',
	MSG_SUBFAMILY_DELETE_ERROR: 'Erro ao excluir subfamília!',
	MSG_MODEL_CREATE_ERROR: 'Erro ao criar modelo!',
	MSG_MODEL_UPDATE_ERROR: 'Erro ao atualizar modelo!',
	MSG_MODEL_DELETE_ERROR: 'Erro ao excluir modelo!',

	MSG_FAMILY_NAME_REQUIRED: 'Nome da família é obrigatório',
	MSG_SUBFAMILY_NAME_REQUIRED: 'Nome da subfamília é obrigatório',
	MSG_MODEL_NAME_REQUIRED: 'Nome do modelo é obrigatório',
	MSG_FAMILY_ALREADY_EXISTS: 'Já existe uma família com este nome',
	MSG_SUBFAMILY_ALREADY_EXISTS: 'Já existe uma subfamília com este nome',
	MSG_MODEL_ALREADY_EXISTS: 'Já existe um modelo com este nome',

	MSG_CONFIRM_DELETE_FAMILY: 'Deseja realmente excluir esta família?',
	MSG_CONFIRM_DELETE_SUBFAMILY: 'Deseja realmente excluir esta subfamília?',
	MSG_CONFIRM_DELETE_MODEL: 'Deseja realmente excluir este modelo?',
	MSG_CONFIRM_DELETE_FAMILIES: 'Deseja realmente excluir estas famílias?',
	MSG_CONFIRM_DELETE_SUBFAMILIES:
		'Deseja realmente excluir estas subfamílias?',
	MSG_CONFIRM_DELETE_MODELS: 'Deseja realmente excluir estes modelos?',

	MSG_DELETE_ALL_SUCCESS: 'Registros excluídos com sucesso!',
	MSG_FAMILIES_DELETE_ALL_SUCCESS: 'As famílias foram excluídas com sucesso',
	MSG_SUBFAMILIES_DELETE_ALL_SUCCESS:
		'As subfamílias foram excluídas com sucesso',
	MSG_MODELS_DELETE_ALL_SUCCESS: 'Os modelos foram excluídos com sucesso',
	MSG_FAMILIES_DELETE_ALL_ERROR: 'Erro ao excluir famílias!',
	MSG_SUBFAMILIES_DELETE_ALL_ERROR: 'Erro ao excluir subfamílias!',
	MSG_MODELS_DELETE_ALL_ERROR: 'Erro ao excluir modelos!',

	MSG_CONFIRM_DELETE_FINAL: 'Essa ação não poderá ser desfeita.',

	LABELS: {
		FAMILY: 'Família',
		SUBFAMILY: 'Subfamília',
		MODEL: 'Modelo',
		FAMILIES: 'Famílias',
		SUBFAMILIES: 'Subfamílias',
		MODELS: 'Modelos',
		CREATE_FAMILY: 'Cadastrar Família',
		CREATE_SUBFAMILY: 'Cadastrar Subfamília',
		CREATE_MODEL: 'Cadastrar Modelo',
		EDIT_FAMILY: 'Editar Família',
		EDIT_SUBFAMILY: 'Editar Subfamília',
		EDIT_MODEL: 'Editar Modelo',
		DELETE_FAMILY: 'Excluir Família',
		DELETE_SUBFAMILY: 'Excluir Subfamília',
		DELETE_MODEL: 'Excluir Modelo',
		FAMILY_NAME: 'Nome da Família',
		SUBFAMILY_NAME: 'Nome da Subfamília',
		MODEL_NAME: 'Nome do Modelo',
		FAMILY_NAME_HEADER: 'Nome da Família',
		SUBFAMILY_NAME_HEADER: 'Nome da Subfamília',
		MODEL_NAME_HEADER: 'Nome do Modelo',
		CANCEL: 'Cancelar',
		DELETE: 'Excluir',
	},

	PLACEHOLDER: {
		FAMILY_NAME: 'Digite o nome da família',
		SUBFAMILY_NAME: 'Digite o nome da subfamília',
		MODEL_NAME: 'Digite o nome do modelo',
		SEARCH_FAMILY: 'Buscar família...',
		SEARCH_SUBFAMILY: 'Buscar subfamília...',
		SEARCH_MODEL: 'Buscar modelo...',
	},

	HOVER: {
		FAMILY_NAME: 'Nome da família',
		SUBFAMILY_NAME: 'Nome da subfamília',
		MODEL_NAME: 'Nome do modelo',
	},

	SCREEN_TITLES: {
		FAMILIES: 'Famílias',
		SUBFAMILIES: 'Subfamílias',
		MODELS: 'Modelos de Produto',
		CREATE_FAMILY: 'Cadastrar Família',
		CREATE_SUBFAMILY: 'Cadastrar Subfamília',
		CREATE_MODEL: 'Cadastrar Modelo',
		EDIT_FAMILY: 'Editar Família',
		EDIT_SUBFAMILY: 'Editar Subfamília',
		EDIT_MODEL: 'Editar Modelo',
	},

	MODAL_TITLES: {
		DELETE_FAMILY: 'Excluir família',
		DELETE_SUBFAMILY: 'Excluir subfamília',
		DELETE_MODEL: 'Excluir modelo de produto',
	},

	DESCRIPTION: {
		FAMILY_DELETE:
			'Você está prestes a excluir esta família da sua base de cadastros.',
		SUBFAMILY_DELETE:
			'Você está prestes a excluir esta subfamília da sua base de cadastros.',
		MODEL_DELETE:
			'Você está prestes a excluir este modelo da sua base de cadastros.',
		FAMILIES_DELETE:
			'Você está prestes a excluir estas famílias da sua base de cadastros.',
		SUBFAMILIES_DELETE:
			'Você está prestes a excluir estas subfamílias da sua base de cadastros.',
		MODELS_DELETE:
			'Você está prestes a excluir estes modelos da sua base de cadastros.',
		FAMILY_DELETE_DETAILED:
			'Você está prestes a excluir esta família, isso resultará na remoção de todos os seus vínculos e históricos.',
		FAMILY_DELETE_ITEMS: 'Orçamento',
		SUBFAMILY_DELETE_DETAILED:
			'Você está prestes a excluir esta subfamília, isso resultará na remoção de todos os seus vínculos e históricos.',
		MODEL_DELETE_DETAILED:
			'Você está prestes a excluir este modelo, isso resultará na remoção de todos os seus vínculos e históricos.',
		DELETE_IRREVERSIBLE: 'Essa ação não poderá ser desfeita.',
	},
} as const;

export type FamilyMessageType =
	(typeof familyMessages)[keyof typeof familyMessages];
